//
//  SDKLogger.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class Logger {
    constructor() {
        this.logs = [];
    }
    log(message) {
        this.logs.push(message);
        console.log(message);
    }
}
